module.exports = __webpack_public_path__ + "img/icon-cross-button-small.9341b903.svg";